export default __webpack_public_path__ + "static/media/cx_cover_fsc56_t2.671615c3.jpg";